const termsBox = document.getElementById('terms-box'),
      checkboxWrap = document.querySelector('.terms-checkbox'),
      checkbox = document.getElementById('product-terms'),
      button = document.querySelector('.product__submit__buttons [data-add-to-cart]'),
      leadtime = document.querySelector('.variant_made_to_orderLeadTime'),
      leadtime_input = document.querySelector('.variant_made_to_orderInput'),
      leadtime_terms = document.querySelector('.variant_made_to_orderTerms');

const variant_leadtime_date = (id) => {
  if (leadtime_data[id] != 'nodate' && leadtime_data[id] != null) {
    leadtime.style.display = 'block';
    leadtime_input.style.display = 'block';
    termsBox.style.display = 'block';
    leadtime_terms.style.display = 'block';
    leadtime.querySelector('.variant_made_to_orderLeadTime').innerHTML = leadtime_data[id];
    var availDate = (typeof availability_date_data !== 'undefined' && availability_date_data[id]) ? availability_date_data[id] : null;
    var dateShipping = availDate ? ' Estimated ship date: ' + availDate + '.' : ' This item will ship ' + leadtime_data[id] + ' weeks from order date.';
    var dateEl = document.querySelector('.variant_availability_date');
    if (dateEl) { dateEl.innerHTML = availDate ? 'Estimated available: ' + availDate : ''; }
    leadtime_input.innerHTML = '<input type="hidden" id="Shipping Details" class="properties variant_leadtimeInput" name="properties[Shipping Details]" value="This is a special order item, that is made to order upon purchase.' + dateShipping + '">';
    leadtime_terms.innerHTML = 'This is currently out of stock or a made to order item.' + dateShipping;


    checkboxWrap.style.display = 'block';
    checkbox.checked = false;
    button.disabled = true;
  } else {
    leadtime.style.display = 'none';
    leadtime_input.style.display = 'none';
    termsBox.style.display = 'none';
    leadtime_terms.style.display = 'none';
    leadtime_input.innerHTML = '<input disabled="disabled" type="hidden" value="" style="display: none;">';

    checkboxWrap.style.display = 'none';
    checkbox.checked = true;
    button.disabled = false;
  }
}

variant_leadtime_date(currentVariantId);
// Subscribe to variant change events so lead time updates when user selects a different variant
if (typeof subscribe === 'function' && window.theme?.PUB_SUB_EVENTS?.variantChange) {
  subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function(event) {
    if (event?.data?.variant?.id) {
      variant_leadtime_date(event.data.variant.id);
    }
  });
}
document.addEventListener('DOMContentLoaded', function() {
  var label = document.querySelector('.terms-checkbox');

  if(typeof(label) != 'undefined' && label != null){
    label.addEventListener("click", checkInput);
    checkInput();

    function checkInput() {
      var checkbox = document.getElementById('product-terms'),
          button = document.querySelector('.product__submit__buttons [data-add-to-cart]');

      if (checkbox.checked) {
        button.disabled = false;
      } else {
        button.disabled = true;
      }
    }
  }
});